(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.common
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.lp-report.export-permissions :as export-perms]
   [common.schema.entities.lp-portal.lp-report :as lp-report]
   [common.util :as cu]
   [frontend.state.current-session :as session]
   [frontend.ui.component.alert.view :refer [alert]]
   [frontend.ui.component.badge.view :as badge]
   [frontend.ui.component.dropdown-button.view :as dropdown-button]
   [frontend.ui.component.file-input.view :as file-input]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.modal-dialog.view :refer [modal-dialog]]
   [frontend.ui.component.table.view :as table]
   [frontend.ui.component.text-input-group.view :refer [text-input-group]]
   [frontend.ui.page.lp-portal.report.util :as ru]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.modal.private-material-bulk-upload-modal
    :as private-material-bulk-upload-modal]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.style :as style]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.utils :as fu :refer [format-data-size]]
   [herb.core :as h]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.loading-spinner.view :as spinner]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.radix-ui.popover.view :as popover]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.components.toggle.view :as toggle]))

(defn add-contact-modal
  [_show?]
  (let [local-state (r/atom {})]
    (fn [show?]
      (let [error @(rf/subscribe [::sub/create-contact-error])]
        [modal-dialog
         {:visible?     show?
          :hide!        #(rf/dispatch [::event/cancel-adding-concat])
          :header-label (loc/tr :add-reporting-contact)
          :size         :xs}
         [:div
          [grid/row {:align-items "center"}
           [grid/column {}
            [text-input-group
             {:title     "Email address"
              :value     (:email @local-state)
              :on-change #(swap! local-state assoc :email %)}]]]
          [grid/row {:align-items "center"}
           [grid/column {}
            [text-input-group
             {:title     "First name"
              :value     (:first-name @local-state)
              :on-change #(swap! local-state assoc :first-name %)}]]]
          [grid/row {:align-items "center"}
           [grid/column {}
            [text-input-group
             {:title     "Last name"
              :value     (:last-name @local-state)
              :on-change #(swap! local-state assoc :last-name %)}]]]
          (when error
            [alert
             {:variant :danger}
             [:span
              (str error)]])]
         [:div
          {:class (h/<class common-style/footer-right)}
          [button/primary-solid
           {:on-click #(rf/dispatch [::event/create-contact @local-state])}
           (loc/tr :save)]]]))))

(defn edit-contact-modal
  []
  (let [association-id @(rf/subscribe [::sub/edit-contact-context])
        error @(rf/subscribe [::sub/edit-contact-error])
        person @(rf/subscribe [::editor-sub/associated-contact-person association-id])
        local-state (r/atom {:email      (:person/universal-email-address person)
                             :first-name (:person/first-name person)
                             :last-name  (:person/last-name person)})]
    (fn []
      [modal-dialog
       {:visible?     (boolean association-id)
        :hide!        #(rf/dispatch [::event/cancel-contact-edit])
        :header-label (loc/tr :edit-reporting-contact)
        :size         :xs}
       [:div
        [grid/row {:align-items "center"}
         [grid/column {}
          [text-input-group
           {:title     "Email address"
            :value     (:email @local-state)
            :on-change #(swap! local-state assoc :email %)}]]]
        [grid/row {:align-items "center"}
         [grid/column {}
          [text-input-group
           {:title     "First name"
            :value     (:first-name @local-state)
            :on-change #(swap! local-state assoc :first-name %)}]]]
        [grid/row {:align-items "center"}
         [grid/column {}
          [text-input-group
           {:title     "Last name"
            :value     (:last-name @local-state)
            :on-change #(swap! local-state assoc :last-name %)}]]]
        (when error
          [alert
           {:variant :danger}
           [:span
            (str error)]])]
       [:div
        {:class "flex gap-3"}
        [button/primary-solid
         {:disabled? (and (= (:email @local-state) (:person/universal-email-address person))
                          (= (:first-name @local-state) (:person/first-name person))
                          (= (:last-name @local-state) (:person/last-name person)))
          :on-click  #(rf/dispatch [::event/update-person (:db/id person) @local-state])}
         (loc/tr :save)]]])))

(defn remove-contact-modal
  []
  (let [[association-id investor-id] @(rf/subscribe [::sub/delete-contact-context])
        error @(rf/subscribe [::sub/delete-contact-error])]
    (fn []
      [modal-dialog
       {:visible?     (boolean association-id)
        :hide!        #(rf/dispatch [::event/cancel-remove-contact])
        :header-label (loc/tr :remove-reporting-contact)
        :size         :xs}
       [:div
        {:class (h/<class common-style/spacing-top-bottom)}
        [grid/row {:align-items "center"}
         [grid/column {}
          [:p (loc/tr :remove-reporting-contact-info-text)]]]
        (when error
          [alert
           {:variant :danger}
           [:span
            (str error)]])]
       [:div
        {:class "flex gap-3"}
        [button/secondary-hollow
         {:on-click (fn [_e]
                      (rf/dispatch [::event/cancel-remove-contact]))}
         (loc/tr :cancel)]
        [button/danger-solid
         {:on-click #(rf/dispatch [::event/remove-reporting-contact investor-id association-id])}
         (loc/tr :ok)]]])))

(defn fund-investors-table
  [report feeder?]
  (let [report-id (:db/id report)
        add-contact-context @(rf/subscribe [::sub/add-contact-context])
        edit-context @(rf/subscribe [::sub/edit-contact-context])
        delete-contact-context @(rf/subscribe [::sub/delete-contact-context])
        investor-contact-options @(rf/subscribe (if feeder?
                                                  [::editor-sub/lp-report-feeder-investor-contacts]
                                                  [::editor-sub/lp-report-investor-contacts]))
        investors-datas (some-> report
                                :lp-report/data
                                :investor-commitments)
        tr-props (table/tr-props {})
        th-props (table/th-props {})
        td-props (table/td-props {})]
    [:div
     {:class (h/<class style/table-background)}
     (when add-contact-context
       [add-contact-modal (boolean add-contact-context)])
     (when edit-context
       [edit-contact-modal])
     (when delete-contact-context
       [remove-contact-modal])
     [:div
      {:class (h/<class common-style/table-wrapper)}
      [:table
       (table/table-props nil)
       [:thead
        [:tr tr-props
         [:th th-props "Investor"]
         [:th th-props "Contacts"]
         [:th th-props "Actions"]]]
       [:tbody (table/tbody-props {})
        (->>
         investors-datas
         :labels
         (map-indexed
          (fn [idx _lbl]
            (let [investor-name (some-> investors-datas
                                        :labels
                                        (nth idx))
                  ext-id (some-> investors-datas
                                 :commitment-uuid
                                 (nth idx))
                  investor-id (or ext-id investor-name)
                  matching-id (->> investor-contact-options
                                   (keep (fn [[name-or-id _]]
                                           (when (->> [investor-name ext-id]
                                                      (remove cu/blank-value?)
                                                      (filter (fn [n]
                                                                (= (cu/str-trim-lcase n)
                                                                   (cu/str-trim-lcase name-or-id))))
                                                      (seq))
                                             name-or-id)))
                                   (first))
                  investor-commitments (get investor-contact-options matching-id)
                  reporting-contacts (->> investor-commitments
                                          (mapcat
                                           (fn [{:keys [_commitment-id reporting-contacts]}]
                                             (->> reporting-contacts
                                                  (map (fn [[aid person]]
                                                         [aid (entity/display-string person)])))))
                                          (doall))
                  commitment-id (->> investor-commitments
                                     (first)
                                     :commitment-id)]
              [investor-name
               ^{:key (str "investor-reports-body-row-" report-id "-" ext-id "-" investor-name)}
               [:tr tr-props
                [:td td-props investor-name]
                [:td td-props
                 (->> reporting-contacts
                      (distinct)
                      (map
                       (fn [[association-id person-name]]
                         (let [kid (str "report-editor-" (:db/id report)
                                        "-investor-" ext-id
                                        "-" association-id)]
                           ^{:key kid}
                           [:div
                            {:style {:display       "inline-block"
                                     :margin-right  ".5rem"
                                     :margin-top    ".25rem"
                                     :margin-bottom ".25rem"}}
                            [dropdown-button/dropdown-button
                             {:title     person-name
                              :variant   :light
                              :size      :xxsmall
                              :on-change (fn [v]
                                           (rf/dispatch [::event/start-contact-action v
                                                         investor-id association-id]))
                              :items     [{:value :edit
                                           :label (loc/tr :edit)}
                                          {:value :delete
                                           :label (loc/tr :remove)}]}]])))
                      (doall))
                 [button/sm-primary-solid
                  {:disabled? (not matching-id)
                   :on-click  (fn [e]
                                (fu/stop-propagation-event! e)
                                (rf/dispatch [::event/start-add-contact investor-id
                                              report-id
                                              commitment-id]))}
                  (loc/tr :add)]]
                [:td td-props
                 (when-not matching-id
                   (let [capman? (some #{(:tenant/name @session/tenant)}
                                       ["CapMan" "CapMan Portal"])]
                     (if capman?
                       [button/sm-primary-solid
                        {:disabled? true}
                        (loc/tr :lp-report-commitment-not-found-in-crm)]
                       [:div
                        {:on-click fu/stop-propagation-event!}
                        [dropdown-menu/view
                         {:trigger
                          [dropdown-menu/button-trigger
                           {:label (loc/tr :lp-report-commitment-not-found-in-crm-create)}]
                          :items
                          [{:key            "create-crm-legal-entity-type-title"
                            :section-label? true
                            :label          (loc/tr :lp-report-legal-entity-type-of-investor)}
                           {:key      "create-crm-company"
                            :label    (loc/tr :entity.type/company)
                            :on-click (fn [_]
                                        (rf/dispatch [::event/create-commitment-to-crm
                                                      {:report-id         report-id
                                                       :investor-name     investor-name
                                                       :external-id       ext-id
                                                       :legal-entity-type :entity.type/company}]))}
                           {:key      "create-crm-contact"
                            :label    (loc/tr :natural-person)
                            :on-click (fn [_]
                                        (rf/dispatch [::event/create-commitment-to-crm
                                                      {:report-id         report-id
                                                       :investor-name     investor-name
                                                       :external-id       ext-id
                                                       :legal-entity-type :entity.type/person}]))}]}]])))]]])))
         (sort-by first)
         (map (fn [[investor-name table-row]]
                ^{:key (str "investor-reports-body-row-" report-id "-" investor-name)}
                table-row))
         (doall))]]]]))

(defn landing-page-table
  [report]
  (let [report @(rf/subscribe [::editor-sub/report (:db/id report)])
        report-data (:lp-report/data report)
        landing-page-data (:fund-landing-page-data report-data)
        tr-props (table/tr-props {})
        th-props (table/th-props {})
        td-props (table/td-props {})]
    [:div
     {:class (h/<class style/table-background)}
     [:div
      {:class (h/<class common-style/table-wrapper)}
      [:table
       (table/table-props nil)
       [:thead
        [:tr tr-props
         [:th th-props (loc/tr :fund-name)]
         [:th th-props (loc/tr :reference-date)]
         [:th th-props (loc/tr :fund-size)]
         [:th th-props (loc/tr :paid-in-pct)]
         [:th th-props (loc/tr :nav-in-currency [(get report :lp-report/currency "EUR")])]
         [:th th-props (loc/tr :cash-called)]
         [:th th-props (loc/tr :fund-tvpi)]
         [:th th-props (loc/tr :fund-net-irr)]]]
       [:tbody (table/tbody-props {})
        [:tr tr-props
         [:td td-props
          (or (:fund-name landing-page-data)
              (:fund-name report-data))]
         [:td td-props
          (fu/format-date-ts (:reference-date report-data) ".")]
         [:td td-props
          (ru/->int (get landing-page-data :fund-size))]
         [:td td-props
          (ru/->percent-1-decimal (:paid-in-pct landing-page-data))]
         [:td td-props
          (ru/->int (:fair-value landing-page-data))]
         [:td td-props
          (ru/->int (:cash-called landing-page-data))]
         [:td td-props
          (ru/->multiple (:tvpi landing-page-data))]
         [:td td-props
          (ru/->percent-1-decimal (:net-irr landing-page-data))]]]]]]))

(defn materials-tab-header
  [{:keys [report-id active-tab dirty?]}]
  [:div
   {:class (h/<class style/tab-header-container)}
   [:div
    {:on-click #(rf/dispatch [::event/set-materials-selected-tab report-id :all])
     :class    (h/<class style/tab-header-button (= active-tab :all))}
    (loc/tr :all-investors)]
   [:div
    {:on-click #(rf/dispatch [::event/set-materials-selected-tab report-id :specific])
     :class    (h/<class style/tab-header-button (= active-tab :specific))}
    (loc/tr :specific-investors)]
   [:div
    {:on-click #(rf/dispatch [::event/set-materials-selected-tab report-id :export-permissions])
     :class    (str (h/<class style/tab-header-button (= active-tab :export-permissions))
                    (when dirty?
                      (str " " (h/<class style/export-perm-tab-dirty))))}
    [:span (loc/tr :export-permissions)]
    (when dirty?
      [tooltip/view
       [:i.fal.fa-exclamation-circle {:class (h/<class style/export-perm-dirty-icon)}]
       (loc/tr :export-permissions/unsaved-changes)])]])

(defn investor-commitment-cell
  [investor-name crm-investor-commitments]
  (let [contacts (->> crm-investor-commitments
                      (mapcat :reporting-contacts)
                      (map second)
                      (map (fn [person]
                             (let [name  (entity/display-string person)
                                   email (:person/universal-email-address person)]
                               (if (seq email)
                                 (str name " (" email ")")
                                 name))))
                      (distinct))
        max-contact-amount (count contacts)
        hidden-contact-amount (- max-contact-amount 1)
        first-contact (first contacts)]
    [:td {:class (h/<class style/investor-cell)}
     [:div {:class (h/<class style/investor-name)} investor-name]
     (when first-contact
       [:div {:class (h/<class style/contact-label)}
        first-contact
        (when (pos? hidden-contact-amount)
          [tooltip/view
           [:span {:class (h/<class style/contact-badge)}
            (str "+" hidden-contact-amount)]
           [:div
            {:style {:display "flex" :flex-direction "column"}}
            (->> (drop 1 contacts)
                 (map (fn [contact-string]
                        ^{:key (str "hidden-contact-" contact-string)}
                        [:span contact-string]))
                 (doall))]])])]))

(defn uploaded-files-list
  [{:keys [materials master-report-id commitment-id]}]
  [:div {:class (h/<class style/file-badges-container)}
   (->> materials
        (map (fn [[attachment-id file]]
               (let [filename (:attachment/filename file)
                     processing? (or (= (:upload/status file) :initializing)
                                     (= (:status file) :uploading-cloud))]
                 [:div {:key   (str "file-badge-" attachment-id)
                        :class (h/<class style/file-badge)}
                  (if processing?
                    [spinner/circle]
                    [tooltip/as-child
                     {}
                     (fn [f-props]
                       [:span
                        (merge (dissoc f-props :className)
                               {:class (h/<class style/file-badge-filename)})
                        filename])
                     filename])
                  [dropdown-menu/view
                   {:trigger [:div {:class "cursor-pointer"} [:i.fas.fa-ellipsis-v]]
                    :items
                    [{:label (loc/tr :download)
                      :on-click (fn []
                                  (rf/dispatch [::event/download-private-material
                                                master-report-id
                                                commitment-id
                                                attachment-id]))}
                     {:label (loc/tr :remove)
                      :on-click (fn []
                                  (rf/dispatch [::event/remove-private-material
                                                master-report-id
                                                commitment-id
                                                attachment-id]))}]
                    :props {:align "end"}}]])))
        (doall))])

(defn upload-files-cell
  [{:keys [materials master-report-id commitment-id investor-name feeder?] :as uploaded-files-data}]
  (r/with-let [popover-open? (r/atom false)]
    [:td {:class (h/<class style/file-cell)}
     [:div {:style {:display "flex"
                    :justify-content "flex-end"}}
      [popover/view
       {:open?          @popover-open?
        :on-open-change #(reset! popover-open? %)}
       [:div
        {:class    (h/<class style/upload-button)
         :on-click (fn [e]
                     (fu/stop-n-prevent e)
                     (swap! popover-open? not))}
        [:i.fal.fa-upload]
        (loc/tr :upload-file-investor)]
       [:div
        [:div {:class (h/<class style/popover-text)}
         (loc/tr :upload-file-investor-alt)]
        [:div {:class (h/<class style/popover-investor-name)}
         investor-name]
        [file-input/file-input
         {:input-id        (str master-report-id "-" commitment-id "-upload")
          :file-types      [".xlsx" ".pdf"]
          :handle-add-file (fn [file]
                             (when file
                               (reset! popover-open? false)
                               (rf/dispatch [::event/start-commitment-material-upload
                                             master-report-id
                                             commitment-id
                                             file
                                             feeder?])))
          :show-drop-area? true}]]]]
     (when (seq materials)
       [uploaded-files-list uploaded-files-data])]))

(defn- visible-investor-commitments
  [lp-report-investor-commitments excel-investors]
  (let [valid-keys (->> excel-investors
                        :labels
                        (map-indexed
                         (fn [idx label]
                           (let [ext-id (some-> excel-investors :commitment-uuid (nth idx))]
                             (or ext-id label))))
                        (set))]
    (->> lp-report-investor-commitments
         (filter (fn [[_ {:keys [lp-report-investor-commitment/investor-name
                                 lp-report-investor-commitment/data]}]]
                   (let [ext-id (:commitment-uuid data)
                         key (or ext-id investor-name)]
                     (contains? valid-keys key))))
         (sort-by (comp :lp-report-investor-commitment/investor-name val)))))

(defn specific-investors-materials-table
  [master-report report feeder?]
  (let [master-report-id (:db/id master-report)
        report-id (:db/id report)
        lp-report-investor-commitments @(rf/subscribe [::editor-sub/lp-report-investor-commitments])
        lp-report-feeder-investor-commitments @(rf/subscribe [::editor-sub/lp-report-feeder-investor-commitments])
        lp-report-investor-commitments (if feeder?
                                         lp-report-feeder-investor-commitments
                                         lp-report-investor-commitments)
        crm-investor-contact-options @(rf/subscribe (if feeder?
                                                      [::editor-sub/lp-report-feeder-investor-contacts]
                                                      [::editor-sub/lp-report-investor-contacts]))
        excel-investors (-> report :lp-report/data :investor-commitments)
        visible-investor-commitments (visible-investor-commitments
                                      lp-report-investor-commitments
                                      excel-investors)
        commitment-options (->> visible-investor-commitments
                                (map (fn [[commitment-id commitment]]
                                       {:commitment-id commitment-id
                                        :investor-name
                                        (:lp-report-investor-commitment/investor-name commitment)
                                        :common/external-id
                                        (:common/external-id commitment)
                                        :private-file-import-id
                                        (:lp-report-investor-commitment/private-file-import-id
                                         commitment)
                                        :materials
                                        (->> (:lp-report-investor-commitment/materials commitment)
                                             (map (fn [[attachment-id attachment]]
                                                    (assoc attachment :db/id attachment-id)))
                                             (sort-by :attachment/filename)
                                             (vec))}))
                                (vec))]
    [:div
     [private-material-bulk-upload-modal/view commitment-options]
     [:div
      {:class (h/<class style/private-material-bulk-upload-actions)}
      [button/sm-secondary-hollow
       {:on-click #(rf/dispatch [::event/open-bulk-upload
                                 master-report-id
                                 report-id
                                 feeder?])}
       (loc/tr :upload-wizard)]]
     [:table
      {:class (h/<class style/specific-investors-table)}
      [:thead
       [:tr
        {:class (h/<class style/table-row)}
        [:th
         {:class (h/<class style/table-header-cell)}
         (loc/tr :investor)]
        [:th
         {:class (h/<class style/table-header-cell-right)}
         (loc/tr :file)]]]
      [:tbody
       (->> visible-investor-commitments
            (map (fn [[commitment-id
                       {:keys [lp-report-investor-commitment/investor-name
                               lp-report-investor-commitment/data
                               lp-report-investor-commitment/materials]}]]
                   (let [ext-id (:commitment-uuid data)
                         matching-id (->> crm-investor-contact-options
                                          (keep (fn [[name-or-id _]]
                                                  (when (some #(= (cu/str-trim-lcase %)
                                                                  (cu/str-trim-lcase name-or-id))
                                                              [investor-name ext-id])
                                                    name-or-id)))
                                          (first))
                         crm-investor-commitments (get crm-investor-contact-options matching-id)]
                     [:tr
                      {:key   (str "specific-row-" commitment-id)
                       :class (h/<class style/table-row)}
                      [investor-commitment-cell investor-name crm-investor-commitments]
                      [upload-files-cell
                       {:materials materials
                        :master-report-id master-report-id
                        :commitment-id commitment-id
                        :investor-name investor-name
                        :feeder? feeder?}]])))
            (doall))]]]))

(defn common-materials-list
  [master-report report]
  (let [all-attachments @(rf/subscribe [::editor-sub/lp-report-attachments (:db/id report)])]
    [:div
     [:div {:class (h/<class style/file-input-wrapper)}
      [file-input/file-input
       {:input-id        (str (:db/id report) "-materials")
        :file-types      [".xlsx" ".pdf"]
        :handle-add-file #(rf/dispatch [::event/start-material-file-upload
                                        (:db/id master-report)
                                        (:db/id report)
                                        %])}]]
     (let [materials (->> report
                          :lp-report/materials
                          (keep (partial get all-attachments))
                          (remove :common/disabled?)
                          (sort-by (comp cu/str-trim-lcase :attachment/filename)))]
       (if (seq materials)
         (doall
          (map (fn [a]
                 ^{:key (str "fund-material-" (:db/id a))}
                 [:div
                  {:class (h/<class style/material-row)}
                  [:div {:class (h/<class style/material-filename)}
                   (:attachment/filename a)]
                  [:div {:class (h/<class style/material-meta-wrapper)}
                   [:span {:class (h/<class style/material-size)}
                    (some-> (:attachment/content-length a)
                            (format-data-size))]
                   [dropdown-menu/view
                    {:trigger [:div {:class "cursor-pointer"} [:i.fas.fa-ellipsis-v]]
                     :items
                     [{:label (loc/tr :download)
                       :on-click #(rf/dispatch [::event/download-material-file
                                                (:db/id report)
                                                (:db/id a)])}
                      {:label (loc/tr :remove)
                       :on-click #(rf/dispatch [::event/remove-material
                                                (:db/id report)
                                                (:db/id a)])}]
                     :props {:align "end"}}]]])
               materials))
         [:div {:class (h/<class style/no-materials-wrapper)}
          [:div {:class (h/<class style/no-materials-title)}
           (loc/tr :no-public-files-yet)]
          [:div {:class (h/<class style/no-materials-subtext)}
           (loc/tr :no-public-files-add)]]))]))

(def export-permission-formats
  [{:key :pdf
    :label "PDF"}
   {:key :xls
    :label "XLS"}
   {:key :json
    :label "JSON"}])

(defn toggle-set-member
  [s x]
  (if (contains? s x)
    (disj s x)
    (conj s x)))

(defn effective-default-formats
  "Effective default format map: the local edit if present, else the report's
  stored default, else the baseline defaults."
  [edits current-permissions]
  (or (:default edits)
      (export-perms/role-formats (:default current-permissions))))

(defn effective-override-formats
  "Effective per-investor override as a flat format map, or nil when the investor
  inherits the default. Reads the local edit first, then the stored value. A
  missing edit (nil) defers to the stored value; an explicit :inherit edit
  clears any stored override."
  [edits current-permissions investor]
  (let [edit (get-in edits [:investors (:commitment-id investor)])]
    (cond
      (= edit :inherit)
      nil

      (map? edit)
      edit

      :else
      (when-let [override (get-in current-permissions [:overrides (export-perms/investor-key investor)])]
        (export-perms/role-formats override)))))

(defn working-permissions
  "The would-be-saved permissions (overrides keyed by investor-key), built from
  the local edits over the stored value. Overrides for investors not currently
  in the report are preserved untouched."
  [edits current-permissions investors]
  (let [visible-keys (set (map export-perms/investor-key investors))
        preserved (apply dissoc (:overrides current-permissions) visible-keys)
        edited (into {}
                     (keep (fn [investor]
                             (when-let [formats (effective-override-formats edits current-permissions investor)]
                               [(export-perms/investor-key investor)
                                {:reporting-contact formats}])))
                     investors)]
    {:default   {:reporting-contact (effective-default-formats edits current-permissions)}
     :overrides (merge preserved edited)}))

(defn export-permissions-dirty?
  [edits current-permissions investors]
  (not= (export-perms/normalize (working-permissions edits current-permissions investors))
        (export-perms/normalize current-permissions)))

(defn export-permission-toggle
  [{:keys [checked? disabled? on-change!]}]
  [toggle/toggle
   {:checked?  (boolean checked?)
    :disabled? disabled?
    :on-change on-change!}])

(defn export-permission-matrix
  [{:keys [perms disabled? on-toggle!]}]
  [:div
   [:div
    {:class (h/<class style/export-perm-header-row)}
    [:div {:class (h/<class style/export-perm-row-label)}]
    (doall
     (for [{:keys [key label]} export-permission-formats]
       ^{:key (str "export-perm-head-" key)}
       [:div
        {:class (h/<class style/export-perm-col-header)}
        label]))]
   [:div
    {:class (h/<class style/export-perm-row)}
    [:div
     {:class (h/<class style/export-perm-row-label)}
     (loc/tr :export-permissions/reporting-contact)]
    (doall
     (for [{:keys [key]} export-permission-formats]
       ^{:key (str "export-perm-cell-" key)}
       [:div
        {:class (h/<class style/export-perm-cell)}
        [export-permission-toggle
         {:checked?   (get perms key)
          :disabled?  disabled?
          :on-change! (fn [v]
                        (on-toggle! key v))}]]))]])

(defn export-permission-review-mark
  [on?]
  (if on?
    [:i.fal.fa-check {:class (h/<class style/export-perm-check)}]
    [:span {:class (h/<class style/export-perm-dash)} "—"]))

(defn export-permission-review-list
  [{:keys [contacts perms]}]
  [:div
   {:class (h/<class style/export-perm-review)}
   [:div
    {:class (h/<class style/export-perm-review-title)}
    (loc/tr :export-permissions/reporting-contact)]
   (doall
    (for [{:keys [id label]} contacts]
      ^{:key (str "export-perm-review-" id)}
      [:div
       {:class (h/<class style/export-perm-review-row)}
       [:div {:class (h/<class style/export-perm-review-label)} label]
       (doall
        (for [{:keys [key]} export-permission-formats]
          ^{:key (str "export-perm-review-mark-" id "-" key)}
          [:div
           {:class (h/<class style/export-perm-cell)}
           [export-permission-review-mark (get perms key)]]))]))])

(defn export-permission-investor-identities
  "Investor list needed for permission bookkeeping: id plus the identity used to
  key overrides. No contact lookups."
  [visible-commitments]
  (mapv (fn [[commitment-id
              {:keys [lp-report-investor-commitment/investor-name
                      lp-report-investor-commitment/data
                      common/external-id]}]]
          {:commitment-id commitment-id
           :investor-name investor-name
           :external-id   (or external-id (:commitment-uuid data))})
        visible-commitments))

(defn export-permission-investors
  [visible-commitments crm-investor-contact-options]
  (mapv (fn [{:keys [investor-name external-id] :as investor}]
          (let [[_ crm-commitments] (cu/find-first
                                     (fn [[name-or-id _]]
                                       (some #(= (cu/str-trim-lcase %)
                                                 (cu/str-trim-lcase name-or-id))
                                             [investor-name external-id]))
                                     crm-investor-contact-options)
                contacts (->> crm-commitments
                              (mapcat :reporting-contacts)
                              (map (fn [[aid person]]
                                     {:id    aid
                                      :label (entity/display-string person)}))
                              (cu/distinct-by :id)
                              (vec))]
            (assoc investor :contacts contacts)))
        (export-permission-investor-identities visible-commitments)))

(defn export-permissions-investor-row
  [{:keys [investor state edits current-permissions default-formats first?]}]
  (let [{:keys [commitment-id investor-name contacts]} investor
        override (effective-override-formats edits current-permissions investor)
        use-default? (nil? override)
        perms (or override default-formats)
        expanded? (contains? (:expanded @state) commitment-id)
        review-expanded? (contains? (:review-expanded @state) commitment-id)
        contact-count (count contacts)]
    [:div
     {:class (h/<class style/export-perm-investor first?)}
     [:div
      {:class    (h/<class style/export-perm-investor-header)
       :on-click (fn []
                   (swap! state update :expanded toggle-set-member commitment-id))}
      [:div
       {:class (h/<class style/export-perm-investor-header-left)}
       [:i {:class (str "fal " (h/<class style/export-perm-chevron) " "
                        (if expanded? "fa-chevron-up" "fa-chevron-down"))}]
       [:div
        [:div {:class (h/<class style/export-perm-investor-name)} investor-name]
        [:div
         {:class (h/<class style/export-perm-investor-contacts-count)}
         (if (pos? contact-count)
           (loc/tr :export-permissions/contacts-count [contact-count])
           (loc/tr :export-permissions/no-contacts))]]]
      [badge/badge
       {:variant (if use-default? :light :success)
        :pill?   true}
       (if use-default?
         (loc/tr :export-permissions/default)
         (loc/tr :export-permissions/custom))]]
     (when expanded?
       [:div
        {:class (h/<class style/export-perm-investor-body)}
        [:div
         {:class (h/<class style/export-perm-default-toggle-row)}
         [:div
          {:class (h/<class style/export-perm-row-label)}
          (loc/tr :export-permissions/default-permissions)]
         [export-permission-toggle
          {:checked?   use-default?
           :on-change! (fn [v]
                         (if v
                           (swap! state assoc-in [:edits :investors commitment-id] :inherit)
                           (swap! state assoc-in [:edits :investors commitment-id] perms)))}]]
        [export-permission-matrix
         {:perms      perms
          :disabled?  use-default?
          :on-toggle! (fn [fmt v]
                        (swap! state update-in [:edits :investors commitment-id]
                               (fn [edit]
                                 (assoc (if (map? edit) edit perms) fmt v))))}]
        (when (pos? contact-count)
          [:div
           [:div
            {:class    (h/<class style/export-perm-review-toggle)
             :on-click (fn []
                         (swap! state update :review-expanded toggle-set-member commitment-id))}
            [:span (loc/tr :export-permissions/review-contacts)]
            [:i {:class (str "fal "
                             (if review-expanded? "fa-chevron-up" "fa-chevron-down"))}]]
           (when review-expanded?
             [export-permission-review-list
              {:contacts contacts
               :perms    perms}])])])]))

(defn export-permissions-table
  [{:keys [report feeder? state]}]
  (let [report @(rf/subscribe [::editor-sub/report (:db/id report)])
        lp-report-investor-commitments @(rf/subscribe
                                         (if feeder?
                                           [::editor-sub/lp-report-feeder-investor-commitments]
                                           [::editor-sub/lp-report-investor-commitments]))
        crm-investor-contact-options @(rf/subscribe
                                       (if feeder?
                                         [::editor-sub/lp-report-feeder-investor-contacts]
                                         [::editor-sub/lp-report-investor-contacts]))
        excel-investors (-> report :lp-report/data :investor-commitments)
        visible (visible-investor-commitments lp-report-investor-commitments excel-investors)
        investors (export-permission-investors visible crm-investor-contact-options)
        current-permissions (:lp-report/export-permissions report)
        edits (:edits @state)
        default-formats (effective-default-formats edits current-permissions)
        dirty? (export-permissions-dirty? edits current-permissions investors)]
    [:div
     {:class (h/<class style/export-perm-container)}
     [:div
      {:class (h/<class style/export-perm-subsection)}
      [:div
       {:class (h/<class style/export-perm-subsection-title)}
       (loc/tr :export-permissions/default-permissions)]
      [:div
       {:class (h/<class style/export-perm-card)}
       [export-permission-matrix
        {:perms      default-formats
         :on-toggle! (fn [fmt v]
                       (swap! state update-in [:edits :default]
                              (fn [d]
                                (assoc (or d default-formats) fmt v))))}]]]
     [:div
      {:class (h/<class style/export-perm-subsection)}
      [:div
       {:class (h/<class style/export-perm-subsection-title)}
       (loc/tr :export-permissions/investors)]
      [:div
       {:class (h/<class style/export-perm-card)}
       (doall
        (for [[idx investor] (map-indexed vector investors)]
          ^{:key (str "export-perm-investor-" (:commitment-id investor))}
          [export-permissions-investor-row
           {:investor            investor
            :state               state
            :edits               edits
            :current-permissions current-permissions
            :default-formats     default-formats
            :first?              (zero? idx)}]))]]
     [:div
      {:class (h/<class style/export-perm-footer)}
      (if dirty?
        [:div
         {:class (h/<class style/export-perm-unsaved)}
         [:i.fal.fa-exclamation-circle]
         [:span (loc/tr :export-permissions/unsaved-changes)]]
        [:div])
      [button/primary-solid
       {:disabled? (not dirty?)
        :on-click  (fn []
                     (rf/dispatch [::event/save-export-permissions
                                   {:report-id   (:db/id report)
                                    :permissions (export-perms/normalize
                                                  (working-permissions edits current-permissions investors))}]))}
       (loc/tr :save)]]]))

(defn materials-table
  [master-report report feeder?]
  (r/with-let [export-perm-state (r/atom {:edits           {}
                                          :expanded        #{}
                                          :review-expanded #{}})]
    (let [report @(rf/subscribe [::editor-sub/report (:db/id report)])
          selected-tab @(rf/subscribe [::editor-sub/materials-selected-tab (:db/id report)])
          commitments @(rf/subscribe
                        (if feeder?
                          [::editor-sub/lp-report-feeder-investor-commitments]
                          [::editor-sub/lp-report-investor-commitments]))
          excel-investors (-> report :lp-report/data :investor-commitments)
          investors (export-permission-investor-identities
                     (visible-investor-commitments commitments excel-investors))
          export-perm-dirty? (export-permissions-dirty? (:edits @export-perm-state)
                                                        (:lp-report/export-permissions report)
                                                        investors)]
      [:div
       {:class (h/<class style/table-background)}
       [materials-tab-header
        {:report-id  (:db/id report)
         :active-tab selected-tab
         :dirty?     export-perm-dirty?}]
       [:div
        {:class (h/<class style/materials-tab-container)}
        (case selected-tab
          :all
          [common-materials-list master-report report]
          :specific
          [:div
           [specific-investors-materials-table master-report report feeder?]]
          :export-permissions
          [export-permissions-table
           {:report  report
            :feeder? feeder?
            :state   export-perm-state}])]])))

(defn fund-report-table
  [report feeder? input-id]
  (let [report @(rf/subscribe [::editor-sub/report (:db/id report)])
        data-file @(rf/subscribe [::editor-sub/lp-report-data-file (:db/id report)])
        owners @(rf/subscribe [::editor-sub/report-owners])
        reporting-ctx {:fund-report   report
                       :master-report @(rf/subscribe [::editor-sub/lp-report])
                       :admin?        @(rf/subscribe [::editor-sub/report-admin?])
                       :account-id    @(rf/subscribe [::editor-sub/account-id])}
        tr-props (table/tr-props {})
        th-props (table/th-props {})
        td-props (table/td-props {})]
    [:div
     {:class (h/<class common-style/table-wrapper)}
     [:table (table/table-props nil)
      [:thead
       [:tr tr-props
        [:th th-props
         (loc/tr :lp-report/title)]
        [:th th-props
         (loc/tr :lp-report/text-contributors)]
        [:th th-props
         (loc/tr :lp-report/text-status)]
        [:th th-props
         (loc/tr :lp-report/data-contributors)]
        [:th th-props
         (loc/tr :lp-report/data-status)]
        [:th th-props
         "Actions"]
        [:th th-props "Data file"]]]
      [:tbody (table/tbody-props {})
       [:tr tr-props
        [:td td-props
         (:lp-report/title report)]
        [:td td-props
         (->> report
              :lp-report/text-contributors
              (map (fn [aid]
                     ^{:key (str "report-editor-contributor-" aid)}
                     [:div
                      {:style {:display      "inline-block"
                               :margin-right ".5rem"}}
                      [badge/badge
                       {:variant :light
                        :pill?   true}
                       (->> owners
                            (cu/filter-by first aid)
                            (first)
                            (last))]]))
              (doall))]
        [:td td-props
         (loc/tr (:lp-report/text-status report))]
        [:td td-props
         (->> report
              :lp-report/data-contributors
              (map (fn [aid]
                     ^{:key (str "report-editor-contributor-" aid)}
                     [:div
                      {:style {:display      "inline-block"
                               :margin-right ".5rem"}}
                      [badge/badge
                       {:variant :light
                        :pill?   true}
                       (->> owners
                            (cu/filter-by first aid)
                            (first)
                            (last))]]))
              (doall))]
        [:td td-props
         (loc/tr (:lp-report/data-status report))]
        [:td td-props
         [:span
          {:class (h/<class common-style/table-cursor-pointer)}
          [:i.fal.fa-edit
           {:style    {:font-size "1.25rem"}
            :on-click (if feeder?
                        #(rf/dispatch [::event/edit-feeder-report report])
                        #(rf/dispatch [::event/edit-fund-report report]))}]]]
        [:td td-props
         [:div
          {:style {:display         "flex"
                   :flex-direction  "row"
                   :justify-content "flex-start"}}
          [:div
           (when data-file
             [:span (:attachment/filename data-file)
              [:br]
              (fu/display-datetime-timestamp (:common/updated-on data-file))])]
          (when data-file
            [:div
             {:style {:padding-left "8px"
                      :flex         "0 0 auto"
                      :align-items  "center"
                      :display      "inline-flex"
                      :font-weight  "bold"}}
             [:span
              {:class (h/<class common-style/table-cursor-pointer)}
              [:i.fal.fa-download
               {:style    {:font-size "1.25rem"}
                :on-click (fn [e]
                            (fu/prevent-default-event! e)
                            (rf/dispatch [::event/download-data-file (:db/id report)
                                          (:db/id data-file)]))}]]])

          (when (and (lp-report/can-update-data? reporting-ctx)
                     (not= (:lp-report/data-status report)
                           :lp-report.publishing-status/approved))
            [:div
             {:style {:padding-left "8px"
                      :flex         "0 0 auto"
                      :align-items  "center"
                      :display      "inline-flex"
                      :font-weight  "bold"}}
             [:span
              {:class (h/<class common-style/table-cursor-pointer)}
              [:i.fal.fa-save
               {:style    {:font-size "1.25rem"}
                :on-click (fn [e]
                            (fu/prevent-default-event! e)
                            (fu/trigger-click input-id))}]]])]]]]]]))
